var map = {
	"./1.webp": 85372,
	"./2.webp": 65049,
	"./3.webp": 54014,
	"./4.webp": 47075,
	"./5.webp": 64032,
	"./6.webp": 37741,
	"./7.webp": 82178,
	"./8.webp": 16455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29803;